<form
  *ngIf="transactionsFilterForm"
  [formGroup]="transactionsFilterForm"
  class="filter-form"
  data-qa-block="filter"
  xmlns:i18nPlural="http://www.w3.org/1999/xhtml"
>
  <tax-input
    taxNumbersOnly
    formControlName="fiscalId"
    placeholder="kkm.search.placeholder"
    data-qa-input="fiscal-id"
    [tabindex]="0"
    [autofocus]="true"
    [clearable]="true"
    [disabled]="!!transactionsFilterForm.value.reportType"
    (cleanEvent)="submitForm()"
  ></tax-input>

  <tax-report-type-filters formControlName="reportType"></tax-report-type-filters>

  <div class="filter-row layout-5-column">
    <tax-datepicker
      class="datepicker"
      data-qa-datepicker="start-date"
      formControlName="startDate"
      label="kkm.settings.date.placeholder"
      [maxDate]="maxDate"
      (inputEvent)="setDate($event, 'startDate')"
    ></tax-datepicker>
    <tax-datepicker
      class="datepicker"
      data-qa-datepicker="end-date"
      formControlName="endDate"
      label="kkm.settings.date.placeholder"
      [maxDate]="maxDate"
      [tooltip]="isIbericaReportSelected ? limitationTooltip : null"
      [isTooltipVisible]="isIbericaReportSelected"
      [startDate]="startDate"
      (inputEvent)="setDate($event, 'endDate')"
    ></tax-datepicker>
    <ng-template #limitationTooltip>
      <div class="analytics-page-tooltip-text" *ngIf="kkmLimitationDays">
        {{ 'analytics.filter.limitations.tooltip.title' | translate }}
        {{ kkmLimitationDays | i18nPlural: daysPlural }}
      </div>
    </ng-template>

    <button
      *ngIf="!isIbericaReportSelected"
      class="button_link"
      data-qa-button="apply-filter"
      (click)="submitForm()"
    >
      {{ 'button.show' | translate }}
    </button>

    <div *ngIf="!isIbericaReportSelected" data-qa-input="shift-number">
      <input
        class="text_field shifts_number"
        placeholder="{{ 'kkm.settings.shifts.placeholder' | translate }}"
        formControlName="shiftNumber"
        data-qa="input"
      />
    </div>

    <a
      *ngIf="!isIbericaReportSelected"
      data-qa-button="download-transactions"
      class="download link_active"
      href="{{ downloadLink }}"
      [matTooltip]="'kkms.kkm.report.tooltip.download.transactions' | translate"
      [matTooltipPosition]="'above'"
    >
      <svg-icon key="download"></svg-icon>
    </a>
  </div>

  <div
    *ngIf="isIbericaReportSelected"
    class="iberica-report-buttons"
    data-qa-block="iberica-report-buttons"
  >
    <button
      class="ui-kit-button_blue"
      data-qa-button="apply-filter"
      (click)="submitForm()"
      [disabled]="!isAllowGetReport"
    >
      {{ 'button.show.result' | translate }}
    </button>
    <button
      class="ui-kit-button_gray"
      data-qa-button="reset-filter"
      (click)="resetFilter()"
      [disabled]="!isActiveButtonResetIbericaReport"
    >
      {{ 'button.reset' | translate }}
    </button>
  </div>
</form>
